import {
  ADD_RENEWAL_TO_CART_API_REQUEST,
  ADD_RENEWAL_TO_CART_API_SUCCESS,
  ADD_RENEWAL_TO_CART_API_ERROR,
  ADD_RENEWAL_TO_CART_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function addRenewalToCartApiRequest() {
  return {
    type: ADD_RENEWAL_TO_CART_API_REQUEST,
    payload: true,
  };
}

function addRenewalToCartApiSuccess(cart, params) {
  return {
    type: ADD_RENEWAL_TO_CART_API_SUCCESS,
    payload: cart,
    params,
  };
}

function addRenewalToCartSuccess(cart, params) {
  return {
    type: ADD_RENEWAL_TO_CART_API_SUCCESS,
    payload: cart,
    params,
  };
}

function addRenewalToCartApiError(err) {
  return {
    type: ADD_RENEWAL_TO_CART_API_ERROR,
    payload: err,
  };
}

export function addRenewalToCartAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    // const { isAuthenticated } = state.auth;
    //   if (!isAuthenticated) {
    //     return dispatch(addRenewalToCartSuccess(params));
    //   }
    dispatch(addRenewalToCartApiRequest());
    return cartApi
      .addRenewalToCart(state, { ...params, paymentType: 'premium' })
      .then(data => {
        dispatch(addRenewalToCartApiSuccess(data, { ...params, paymentType: 'premium' }));
        return data;
      })
      .catch(error => {
        dispatch(addRenewalToCartApiError(error));
        throw error;
      });
  };
}

export default { addRenewalToCartAction };
